import api from '@/lib/axios'

export interface SendTaskInput {
  assignedTo: string
  title: string
  note?: string
  dueDate?: string
  source?: string
  // CFAdollars set aside now and paid when they mark it done (leaders with allowance)
  rewardAmount?: number
}

export interface PersonalTask {
  _id: string
  title: string
  note?: string
  dueDate?: string
  status: 'open' | 'completed' | 'cancelled'
  source?: string
  reward?: { amount: number; paid: boolean } | null
}

export async function sendPersonalTask(input: SendTaskInput): Promise<PersonalTask> {
  const { data } = await api.post('/api/personal-tasks', input)
  return data
}

export interface MyPersonalTasks {
  tasks: PersonalTask[]
  // Mirrors the store's toggle + policy gate createPersonalTask enforces server-side,
  // so the client can hide the quick-add entry point instead of offering it and 403ing.
  canCreate: boolean
}

export async function listMine(): Promise<MyPersonalTasks> {
  const { data } = await api.get('/api/personal-tasks/mine')
  return { tasks: data?.tasks || [], canCreate: Boolean(data?.canCreate) }
}

export async function completePersonalTask(id: string, completionNote?: string): Promise<PersonalTask> {
  const { data } = await api.patch(`/api/personal-tasks/${id}/complete`, { completionNote })
  return data
}

export async function cancelPersonalTask(id: string): Promise<PersonalTask> {
  const { data } = await api.patch(`/api/personal-tasks/${id}/cancel`)
  return data
}

export async function nudgePersonalTask(id: string): Promise<PersonalTask> {
  const { data } = await api.post(`/api/personal-tasks/${id}/nudge`)
  return data
}

export interface AssignableUser {
  _id: string
  name: string
  position: string
}

// Reuses the endpoint shift-task assignment already uses: it returns every
// active user at the store to any caller, which is exactly the picker's needs.
export async function fetchAssignableUsers(): Promise<AssignableUser[]> {
  const { data } = await api.get('/api/users', { params: { forTaskAssignment: 'true' } })
  return data?.users || []
}
